<template>
  <el-config-provider :locale="appStore.locale" :size="appStore.size">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import useSettingsStore from '@/store/modules/settings';
import { handleThemeStyle } from '@/utils/theme';
import useAppStore from '@/store/modules/app';

const appStore = useAppStore();

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme);
  });
});
</script>
<style>
.air_main {
  width: 100%;
  height: calc(100vh - 98px);
  min-height: 700px;
  background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;
}

.w-main {
  width: 100%;
  height: calc(100vh - 100px);
}
.line_feed {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
